// Shared-book-details reuse for Build Your Own.
//
// This is deliberately a SNAPSHOT copy, not a hidden link. Compatible values
// are copied from Book Writing into ordinary target posting fields, so existing
// autosave, hydration, validation, review, and order creation keep owning them.
// Only empty target fields are filled. A customer-entered target value is never
// replaced, and later Book Writing edits never overwrite a target override.

const categoryFor = (source = {}) => {
  if (source.fiction === true) return source.genre
  if (source.fiction === false) return source.niche
  return null
}

const translationCategoryFor = (source = {}) => {
  if (source.fiction === true) return "Fiction"
  if (source.fiction === false) return "Non-fiction"
  return null
}

const COMPATIBILITY = {
  book_description: {
    title: "title",
    subtitle: "subtitle",
    niche: (source) => source.niche,
  },
  content_translation: {
    title: "title",
    subtitle: "subtitle",
    author_name: "author_name",
    word_count: "word_count",
    category: translationCategoryFor,
    niche: (source) => source.niche,
  },
  cover_design: {
    title: "title",
    subtitle: "subtitle",
    author_name: "author_name",
    niche: categoryFor,
  },
  editing: {
    title: "title",
    subtitle: "subtitle",
    word_count: "word_count",
    niche: (source) => source.niche,
  },
  formatting: {
    title: "title",
    subtitle: "subtitle",
    word_count: "word_count",
  },
  humanize_ai: {
    title: "title",
    subtitle: "subtitle",
    author_name: "author_name",
    fiction: "fiction",
    word_count: "word_count",
    genre: "genre",
    niche: "niche",
  },
  illustration: {
    title: "title",
    subtitle: "subtitle",
    author_name: "author_name",
    niche: categoryFor,
  },
  narration: {
    title: "title",
    subtitle: "subtitle",
    fiction: "fiction",
    word_count: "word_count",
    niche: categoryFor,
  },
  outline: {
    title: "title",
    subtitle: "subtitle",
    word_count: "word_count",
    writing_style: "writing_style",
    genre: "genre",
    niche: "niche",
  },
  plagiarism: {
    title: "title",
    subtitle: "subtitle",
    word_count: "word_count",
  },
}

const isEmpty = (value) => {
  if (value == null) return true
  if (typeof value === "string") return value.trim() === ""
  if (Array.isArray(value)) return value.length === 0
  return false
}

const sourceValue = (source, selector) =>
  typeof selector === "function" ? selector(source) : source[selector]

export function canCopyBookDetailsTo(serviceKey) {
  return Object.prototype.hasOwnProperty.call(COMPATIBILITY, serviceKey)
}

export function copyBookDetailsSnapshot(source = {}, target = {}, serviceKey) {
  const fields = COMPATIBILITY[serviceKey]
  if (!fields) return { posting: target, copied: [] }

  const posting = { ...target }
  const copied = []

  for (const [targetKey, selector] of Object.entries(fields)) {
    const value = sourceValue(source, selector)
    if (isEmpty(value) || !isEmpty(posting[targetKey])) continue

    posting[targetKey] = value
    copied.push(targetKey)
  }

  return { posting, copied }
}
